import React from "react";
import { Route, Routes } from "react-router-dom";
import { HistoryPage } from "./pages/history-page";

const HistoryFeature: React.FC = () => {
  return (
    <Routes>
      <Route index element={<HistoryPage />} />
    </Routes>
  );
};

export default HistoryFeature;
